import clientAxios from "../../client";

import { formatQueryString } from "@/common/utils/common";

import type { AnalysisType } from "@/common/types/analysis";

export async function analysisList(
  account_id: string,
  query?: { [key: string]: any },
) {
  const queryString = formatQueryString(query);

  return await clientAxios.get(
    `account/${account_id}/analysis/list${queryString}`,
  );
}

export async function analysisCreate(
  account_id: string,
  evaluation_id: string,
) {
  return await clientAxios.post(`account/${account_id}/analysis/create`, {
    evaluation_id,
  });
}

export async function analysisShow(account_id: string, analysis_id: string) {
  return await clientAxios.get(
    `account/${account_id}/analysis/${analysis_id}/show`,
  );
}

export async function analysisReport(account_id: string, analysis_id: string) {
  return await clientAxios.get(
    `account/${account_id}/analysis/${analysis_id}/report`,
  );
}

export async function analysisPatch(
  account_id: string,
  analysis_id: string,
  payload: Partial<AnalysisType>,
) {
  return await clientAxios.patch(
    `account/${account_id}/analysis/${analysis_id}/patch`,
    {
      payload,
    },
  );
}

export async function analysisUpdate(
  account_id: string,
  analysis_id: string,
  payload: AnalysisType,
) {
  return await clientAxios.put(
    `account/${account_id}/analysis/${analysis_id}/update`,
    payload,
  );
}

export async function analysisDelete(account_id: string, analysis_id: string) {
  return await clientAxios.del(
    `account/${account_id}/analysis/${analysis_id}/delete`,
  );
}

export async function analysisStart(account_id: string, analysis_id: string) {
  return await clientAxios.post(
    `account/${account_id}/analysis/${analysis_id}/start`,
    {},
  );
}

export async function analysisCancel(account_id: string, analysis_id: string) {
  return await clientAxios.post(
    `account/${account_id}/analysis/${analysis_id}/cancel`,
    {},
  );
}

export async function analysisStop(account_id: string, analysis_id: string) {
  return await clientAxios.post(
    `account/${account_id}/analysis/${analysis_id}/stop`,
    {},
  );
}

export async function analysisCopy(account_id: string, analysis_id: string) {
  return await clientAxios.post(
    `account/${account_id}/analysis/${analysis_id}/copy`,
    {},
  );
}
